import axios from "axios";
//import LocalStorageService from "./services/storage/localstorageservice";
import router from "../router";
var parse = require("json-parse-safe");

import Vue from "vue";

function getStoredAuthData() {
  const rawToken = localStorage.getItem("token");

  if (!rawToken) return null;

  const parsed = parse(<any>rawToken);

  if (!parsed.value) return null;

  if (typeof parsed.value === "string") return { token: parsed.value };

  return parsed.value;
}

function getAccessToken(authData = getStoredAuthData()) {
  if (!authData) return null;

  if (authData.token && typeof authData.token === "object") return authData.token.token;
  if (authData.token && typeof authData.token === "string") return authData.token;

  return null;
}

function getRefreshToken() {
  const authData = getStoredAuthData();

  if (!authData) return null;

  if (authData.token && typeof authData.token === "object") {
    return authData.token.refreshToken || authData.token.refresh_token || null;
  }

  return authData.refreshToken || authData.refresh_token || null;
}

function persistAuthData(data) {
  const tokenData = data && data.content ? data.content : data;
  const currentAuthData = getStoredAuthData();

  if (!tokenData || !tokenData.token) return null;

  if (currentAuthData && currentAuthData.token && typeof currentAuthData.token === "object") {
    const nextAuthData = {
      ...currentAuthData,
      token: tokenData,
    };

    localStorage.setItem("token", JSON.stringify(nextAuthData));
    return nextAuthData;
  }

  localStorage.setItem("token", JSON.stringify(tokenData));
  return tokenData;
}

const runtimeVariables = (window as any).variables || {};
const runtimeApiBaseUrl = runtimeVariables.API_BASE_URL;

axios.defaults.baseURL =
  (runtimeApiBaseUrl && !runtimeApiBaseUrl.includes("${") ? runtimeApiBaseUrl : "") ||
  process.env.API_BASE_URL ||
  process.env.VUE_APP_API_URL ||
  "https://api.brizolaejapur.com.br";
// axios.defaults.baseURL = "http://localhost:3500";
// axios.defaults.baseURL = "https://brizolaejapur-backend-api-0ba6563c28db.herokuapp.com/";
// axios.defaults.baseURL = "https://seal-app-5zuf2.ondigitalocean.app";

let refreshTokenRequest: Promise<string | null> | null = null;

async function refreshAccessToken() {
  if (!refreshTokenRequest) {
    refreshTokenRequest = new Promise((resolve, reject) => {
      const refreshToken = getRefreshToken();

      if (!refreshToken) {
        reject(new Error("Refresh token não encontrado"));
        return;
      }

      axios
        .post("/api/refresh-token", { refresh_token: refreshToken })
        .then((response) => {
          const tokenData = persistAuthData(response.data);
          resolve(getAccessToken(tokenData));
        })
        .catch(reject)
        .finally(() => {
          refreshTokenRequest = null;
        });
    });
  }

  return refreshTokenRequest;
}

function redirectToHome() {
  localStorage.clear();
  router.push("/home");
}

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = getAccessToken();

    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config || {};
    const originalRequestUrl = originalRequest.url || "";
    const status = error.response ? error.response.status : error.request ? error.request.status : null;

    if (status == 0) {
      return Promise.reject(error);
    }

    if (
      status === 401 &&
      !originalRequest._retry &&
      !originalRequestUrl.includes("/login") &&
      !originalRequestUrl.includes("/api/refresh-token")
    ) {
      originalRequest._retry = true;

      return refreshAccessToken()
        .then((token) => {
          if (!token) {
            redirectToHome();
            return Promise.reject(error);
          }

          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers["Authorization"] = "Bearer " + token;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          return axios(originalRequest);
        })
        .catch((refreshError) => {
          redirectToHome();
          return Promise.reject(refreshError);
        });
    }

    if (status === 401 && !originalRequestUrl.includes("/login")) {
      redirectToHome();
      return Promise.reject(error);
    }

    // if (error.response.status === 419 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   const token = parse(<any>localStorage.getItem("token"));

    //   return axios
    //     .get(
    //       `/sessions/${token.value.session}/access/new?access=${token.value.access}`
    //     )
    //     .then((res) => {
    //       if (res.status === 200) {
    //         localStorage.setItem("token", JSON.stringify(res.data.data));
    //         axios.defaults.headers.common["Authorization"] =
    //           "Bearer " + res.data.data.access;
    //       }
    //       return axios(originalRequest);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       router.push("/login");
    //       return Promise.reject(error);
    //     });
    // }

    //check error format
    if (error.response && error.response.data && "success" in error.response.data) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error);
  }
);

const publicAxios = axios.create({
  // baseURL: 'http://localhost:3001'
  // baseURL: 'https://api2-hml.rj123milhas.com.br'
  baseURL: 'https://brizolaejapur-backend-api-0ba6563c28db.herokuapp.com/'
});

Vue.prototype.$publicAxios = publicAxios;
